import { UserUI } from '@src/models';
import { DECISION_TYPE_CODE } from '@src/constants';
import { _ } from '@ngx-translate/core';

import { GroupedListType } from '../types';

export const getGroupsUsers = (items: UserUI[]) => {
  const groups: GroupedListType[] = [];

  groups.push({
    title: _('components.list.constants.decisionTypeCode.accepted'),
    items: items.filter(item => item.decisionTypeCode === DECISION_TYPE_CODE.Accepted),
  });

  groups.push({
    title: _('components.list.constants.decisionTypeCode.passed'),
    items: items.filter(item => item.decisionTypeCode === DECISION_TYPE_CODE.Passed),
  });

  groups.push({
    title: _('components.list.constants.decisionTypeCode.readed'),
    items: items.filter(
      item =>
        item.decisionTypeCode === DECISION_TYPE_CODE.Sended || item.decisionTypeCode === DECISION_TYPE_CODE.Readed,
    ),
  });

  groups.push({
    title: _('components.list.constants.decisionTypeCode.rejected'),
    items: items.filter(item => item.decisionTypeCode === DECISION_TYPE_CODE.Rejected),
  });

  return groups;
};
